import { Link } from "react-router-dom";

const progress_statuses = [
  { name: "Oczekujące", value: "pending" },
  { name: "Katalogowanie", value: "specification" },
  { name: "Kategoria", value: "category" },
  { name: "Grafika", value: "images" },
  { name: "Content", value: "content" },
  { name: "Deploy", value: "to_export" },
  { name: "Zakończone", value: "done" },
];

const StatusesList = ({ data, refetch, is_refetching, progress_status }) => {
  return (
    <div className="statuses-list">
      <button
        type="button"
        disabled={is_refetching}
        onClick={refetch}
        className="statuses-list__refetch"
      >
        <span>{is_refetching ? "Proszę czekać..." : "Odśwież"}</span>
      </button>
      {progress_statuses.map(({ name, value }) => (
        <Link
          key={name}
          className={value === progress_status ? "active" : ""}
          to={`/workflows${value ? `/${value}` : ""}`}
        >
          <span className={`pill ${value === "done" ? "success" : "warning"}`}>
            {value ? data[value] || "-" : data["all"]}
          </span>{" "}
          {name}
        </Link>
      ))}
    </div>
  );
};

export default StatusesList;
